import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import InputCreditCard from "../../../shared/atoms/InputCreditCard";
import SelectForm from "../../../shared/atoms/SelectForm";
import InputForm from "../../../shared/atoms/InputForm";
import { getUserToken } from "../../shared/utils";
import jwt_decode from "jwt-decode";
import { getInstallmentsResale } from "../../shared/requests-api";
import { Button, MaxModal } from "@maxmilhas/hangar-components-atomic/public";
import Modal from '../../../shared/create-offer/Modal/Modal';
import { postPaymentResale } from '../../shared/requests-api';
import Loading from '../../../shared/create-offer/Loading/Loading';

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

const yearsOptions = new Array(15).fill().map((it, idx) => {
	let year = idx + currentYear;
	return { value: year, label: year };
});

const monthOptions = [
	{ label: "Jan", value: "01" },
	{ label: "Fev", value: "02" },
	{ label: "Mar", value: "03" },
	{ label: "Abr", value: "04" },
	{ label: "Mai", value: "05" },
	{ label: "Jun", value: "06" },
	{ label: "Jul", value: "07" },
	{ label: "Ago", value: "08" },
	{ label: "Set", value: "09" },
	{ label: "Out", value: "10" },
	{ label: "Nov", value: "11" },
	{ label: "Dez", value: "12" }
];

const BoxResaleCreditCard = ({closeResale, total}) => {
	const [details, setDetails] = useState(null);
	const [installmentOptions, setInstallmentOptions] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [formFilled, setFormFilled] = useState(false);
	const [paymentInProgress, setPaymentInProgress] = useState(false);   

	const [paymentData, setPaymentData] = useState({
		cardNumber: '',
		holderName: '',
		expirationMonth: '',
		expirationYear: '',
		cvv: '',
		activeBrand: undefined,
		installments: ''
	});

	const { cardNumber, holderName, expirationMonth, expirationYear, cvv, installments, activeBrand } = paymentData;

	const userToken = getUserToken();
	const userPayload = jwt_decode(userToken);

	const [errors, setErrors] = useState({
		errors: {
			cardNumber: false,
			holderName: false,
			expirationMonth: false,
			expirationYear: false,
			cvv: false,
			installments: false
		}
	});

	const checkAllFilled = () => {
		const fieldsIsCompleted =
			!!cardNumber.length &&
			!!holderName.length &&
			!!expirationMonth.length &&
			!!expirationYear.length &&
			!!cvv.length &&
			!!installments.length &&
			!errors.cardNumber &&
			!errors.holderName &&
			!errors.expirationMonth &&
			!errors.expirationYear &&
			!errors.cvv &&
			!errors.installments;

		return fieldsIsCompleted;
	}

	const onChange = (event, det = details) => {
		const { name, value } = event.target;
		let newValue = value;

		switch (name) {
			case "cvv":
				newValue = String(newValue).replace(/[^0-9.]/g, "");
				setDetails(det);

				setErrors({
					...errors,
					cvv: !newValue.length || !det || det.code.size !== newValue.length
				});

				setPaymentData({ ...paymentData, [name]: newValue });
				break;

			case "cardNumber":
				newValue = String(newValue).replace(/[^0-9.]/g, "");
				setDetails(det);

				setErrors({
					...errors,
					cardNumber: !activeBrand || !det || !det.lengths.find(l => l === newValue.length),
					cvv: !!cvv.length && !!det && det.code.size !== cvv.length
				});

				setPaymentData({ ...paymentData, [name]: newValue, activeBrand });
				break;

			case "expirationMonth":

					setErrors({
						...errors,
						expirationMonth: !value.length || (currentYear == expirationYear && value < currentMonth)
					});

				setPaymentData({ ...paymentData, [name]: newValue });
				break;

			case "expirationYear":

				setErrors({
					...errors,
					expirationMonth:
						!value.length || (currentYear == value && expirationMonth < currentMonth)
				});

				setPaymentData({ ...paymentData, [name]: newValue });
				break;

			case "holderName":
				newValue = String(newValue).replace(/[0-9]/g, "");

				setErrors({
					...errors,
					holderName: !newValue.length
				});

				setPaymentData({ ...paymentData, [name]: newValue });
				break;

			case "installments":
				setErrors({
					...errors,
					installments: !newValue.length
				});
				setPaymentData({ ...paymentData, [name]: newValue });

			default:
				setPaymentData({ ...paymentData, [name]: value });
				break;
		}
	}
	
	const getInstallments = () => {
		const { username } = userPayload;

        getInstallmentsResale(username).then(response => {
			const { installmentsValue } = response.data && response.data.installments;
			setInstallmentOptions(installmentsValue.map(item => ({ label: item.installmentTextDetail, value: item.installment })));

        }).catch(error => {
            console.error(error);
        })
    }

	useEffect(() => {
		setFormFilled(checkAllFilled());
	}, [paymentData]);

	useEffect(() => {
		getInstallments();
	}, [])

	const confirmPayment = () => {
		const { id } = userPayload;
		setPaymentInProgress(true);

		const payment = {
			idUser: id,
			amount: total,
			choice: 'C',
			creditCard: {
				number: cardNumber,
				holderName: holderName,
				expirationMonth: expirationMonth,
				expirationYear: parseInt(expirationYear),
				cvv: cvv,
				brand: activeBrand,
				installments: parseInt(installments)
			}
		}

		postPaymentResale(payment).then(response => {
			setShowModal(true);
			setPaymentMade(true);
			setPaymentInProgress(false);
		}).catch(error => {
			console.error(error);
			setPaymentInProgress(false);
		});
	}

	const { innerWidth } = window;
	
	return (
		<>
			{paymentInProgress && <div className="resale-form__page-loading">
				<Loading width={75} height={75} />
			</div>}

			<p className="credit-card__box-title">Dados do cartão de crédito</p>
			<div className="row">
				<div className="col-xs-16">
					<SelectForm
						name="installments"
						options={installmentOptions}
						value={installments}
						onChange={onChange}
						defaultOption="Escolha a opção de pagamento"
						label="Em quantas parcelas deseja pagar?*"
						errorMessage="Selecione uma opção"
						hasError={errors.installments}
						data-action="resale-credit-installments"
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-16">
					<InputForm
						name="holderName"
						id="holderName"
						value={holderName}
						onChange={onChange}
						label="Titular do cartão*"
						placeholder="Digite igual ao impresso no cartão"
						errorMessage="Campo obrigatório"
						maxLength={150}
						hasError={errors.holderName}
						data-action="resale-credit-card-name"
					/>
				</div>
				<div className="col-xs-16 col-md-8 col-lg-6">
					<InputCreditCard
						name="cardNumber"
						id="cardNumber"
						value={cardNumber}
						onChange={onChange}
						placeholder="Digite somente números"
						label="Número do cartão*"
						errorMessage="Número inválido"
						maxLength={30}
						hasError={errors.cardNumber}
						data-action="resale-credit-card-number"
						getActiveBrand={activeBrand => setPaymentData({...paymentData, activeBrand})}
					/>
				</div>
				<div className="col-xs-8 col-lg-2">
					<SelectForm
						name="expirationMonth"
						options={monthOptions}
						value={expirationMonth}
						onChange={onChange}
						defaultOption="Mês"
						label="Validade*"
						errorMessage="Data inválida"
						hasError={errors.expirationMonth}
						data-action="resale-credit-card-valid-month"
					/>
				</div>
				<div className="col-xs-8 col-lg-2">
					<SelectForm
						name="expirationYear"
						options={yearsOptions}
						value={expirationYear}
						onChange={onChange}
						defaultOption="Ano"
						label={"\u00A0"}
						errorMessage={errors.expirationMonth ? "" : "Data inválida"}
						hasError={errors.expirationYear}
						data-action="resale-credit-card-valid-year"
					/>
				</div>
				<div className="col-xs-16 col-md-8 col-lg-6">
					<i
						className="tooltip__label-container--tooltip tooltip tooltip__label-container--tooltip-resale gray"
						data-tooltip='Código localizado no verso do cartão de crédito. Geralmente possui 3 ou 4 dígitos.'
						data-flow={innerWidth > 992 && innerWidth < 1417 ? "left" : "up"}
					>
						?
					</i>
					<InputForm
						name="cvv"
						id="cvv"
						type="tel"
						value={cvv}
						onChange={onChange}
						label="CVV*"
						placeholder="3 ou 4 dígitos"
						errorMessage="Código inválido"
						maxLength={details ? details.code.size : 4}
						hasError={errors.cvv}
						data-action="resale-credit-card-security-code"
					/>
				</div>
			</div>
			<div className="resale-form__buttons">
				<div className="resale-form__buttons resale-form__buttons--back">
					<Button
						outline={true}
						color="#1abc9c"
						onClick={() => closeResale(false)}
						size="normal"
						type="button"
					>
						Voltar
                    </Button>
				</div>

				<div className="resale-form__buttons resale-form__buttons--confirm">
					<Button
						color="green"
						disabled={!formFilled}
						onClick={() => confirmPayment()}
						size="normal"
						type="button"
					>
						Confirmar pagamento
                    </Button>
				</div>
			</div>

			<Modal
				show={showModal}
				fixed={true}
				title={<p className="modal__title modal">Pagamento realizado</p>}
				description={<div className="modal__description">Seu pagamento será processado e, assim que confirmado, vamos quitar o seu débito.</div>}
				confirm="Ok, entendi"
				onConfirm={() => { setShowModal(false) }}
				width={360}
				height={220}
			/>
		</>
	);
}

BoxResaleCreditCard.propTypes = {
	className: PropTypes.string,
};

export default BoxResaleCreditCard;
